import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdvancedSearchPage } from './advanced-search';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    AdvancedSearchPage,
  ],
  imports: [
    IonicPageModule.forChild(AdvancedSearchPage),
    NgMultiSelectDropDownModule.forRoot(),
    ComponentsModule
  ],
})
export class AdvancedSearchPageModule {}



// WEBPACK FOOTER //
// ./src/pages/advanced-search/advanced-search.module.ts